module.exports = __webpack_public_path__ + "packs/media/images/image_smile-ed2ac62135e2608b698c6e15edfe9ef0.png";